import { zh as privatisation_zh } from './privatisation/zh';
import { zh as google } from './gogole/zh';

const zh_CN = {
    'header_title': '开发者平台',
    'home_title': '青萍开发者平台',
    'do_yourself': '规则，由你来定',
    'deep_customize': '让⻘萍产品完美接入您的平台',
    'start': '预览',
    'login': '登录',
    'cancel': '取消',
    'checkout_docs': '查看文档',
    'consent': '确认',
    'consent_title': '授权获取如下信息：',

    'welcome': '登录',
    'phone': '手机号',
    'phone_login': '手机号',
    'email_login': '邮箱',
    'password': '密码',
    'code': '验证码',
    'send': '发送验证码',
    'via_email': '邮箱登录',
    'via_password': '密码登录',
    'via_verify': '验证码登录',
    'email': '邮箱',
    'desc_1': '请使用青萍账号登录。如没有账号，请先下载',
    'desc_1_1': '青萍物联',
    'desc_2': '或',
    'desc_3': '青萍+',
    'desc_4': ' app 注册。',
    'input_account': '请输入账号',
    'input_correct': '请输入正确的',
    'email_txt': '邮箱格式',
    'phone_txt': '手机号',

    'docs': '文档',
    'get_stared': '开始使用1',
    'guideline': '接入指引',
    'qingping_air_monitor': '青萍空气检测仪',
    'dany': '青萍空气检测仪 Lite',
    'RH_WIFI': '青萍温湿度气压计 Wi-Fi 版',
    'RH_NB_IOT': '青萍温湿度气压计 NB-IoT 版',
    'RH_LoRa': '青萍温湿度气压计 LoRa 版',
    'RH_PRO_WIFI': '青萍商用温湿度计 Wi-Fi 版',
    'RH_PRO_NB_IOT': '青萍商用温湿度计 NB-IoT 版',
    'access': '接入',
    'instruction': '规范说明',
    'OAuth': 'OAuth 2.0 认证',
    'open_interface': '开放接口',
    'data_push': '数据推送',
    'SDK_instruction': 'SDK 支持说明',
    'private_cloud': '产品私有化',
    'private_deployment': '私有化',
    'SDK': 'SDK',
    'RH_LoRa_WAN': '青萍温湿度气压计 LoRaWAN 协议',

    'my': '我的',
    'access_managemennt': '权限管理',
    'apply_access': '权限申请',
    'access_information': '权限管理',
    'apply_app_key_and_app_secret': '申请 App Key 和 App Secret',
    'data_push_setting': '数据推送设置',
    'webhook_setting': 'Webhook 设置',
    'MQTT_setting': 'MQTT 设置',
    'device_data_webhook': '设备数据接收 Webhook',
    'address_optional': '请输入接收地址（选填）',
    'device_time_webhook': '设备事件接收 Webhook',
    'edit': '编辑',
    'others': '其他',
    'feedback': '问题反馈',
    'issueTip': '请在青萍+ app 或青萍物联 app 的“更多 > 联系我们”功能中提交您的问题。谢谢。',
    'help': '请描述您所需要帮助的问题，或提出您的宝贵建议。',
    'contact': '请输入您的手机号，微信号或邮箱方便我们与您取得联系。',
    'feedback_suggestion': '问题反馈',
    'logout': '登出',
    'apply': '申请',
    'save': '保存',
    'clear': '清空',
    'before': '前缀',
    'data': '数据',
    'event': '事件',
    test: '连接测试',
    confirm: '确定',
    add: '新增',

    "account_or_password_error": "账号或密码错误",
    "captcha_limit_exceeded": "验证码已超过限制次数",
    "username_or_password_limit_exceeded": "用户名或密码错误已超过限制次数",
    "user_type_error": "用户类型不对",

    login_failed_pwd_error: '密码错误，请重新输入，或使用验证码登录。',
    login_failed_account_not_exist: '账号不存在。',
    verification_to_many: '验证次数过多，请 10 分钟后再试。',
    verification_code_error: '验证码错误，请确认后再试。',

    ...privatisation_zh,
    ...google,
};

export default zh_CN;
